import { z } from 'zod';

const zodColumnNameMapSchema = z.object({
  expected: z.enum([
    'number',
    'name',
    'account_type',
    'cost_type',
    'valid_from',
  ]),
  nameInFile: z.string().trim().min(1),
});

const zodImportLedgerAccountsPayloadBaseSchema = z.object({
  columnNamesMap: z.array(zodColumnNameMapSchema),
  file: z.instanceof(Blob),
  isDryRun: z.boolean().default(true),
  validFrom: z.iso.date().nullable(),
});

export const zodImportLedgerAccountsPayloadSchema = z.discriminatedUnion(
  'applyToAllCompaniesInAccount',
  [
    zodImportLedgerAccountsPayloadBaseSchema.extend({
      applyToAllCompaniesInAccount: z.literal(false).default(false),
      companyIds: z.array(z.uuid()).min(1),
    }),
    zodImportLedgerAccountsPayloadBaseSchema.extend({
      applyToAllCompaniesInAccount: z.literal(true),
      companyIds: z.array(z.uuid()).nullable(),
    }),
  ],
);

export const zodImportLedgerAccountsResponseSchema = z.object({
  affectedCompaniesCount: z.number().int().nonnegative(),
  existingAccountsCount: z.number().int().nonnegative(),
  importedDeleted: z.number().int().nonnegative(),
  importedNew: z.number().int().nonnegative(),
  importedUpdated: z.number().int().nonnegative(),
  received: z.number().int().nonnegative(),
  resultsCount: z.number().int().nonnegative(),
  skippedDuplicate: z.number().int().nonnegative(),
  skippedInvalid: z.number().int().nonnegative(),
  successfullyImported: z.number().int().nonnegative(),
});
